import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SummaryType } from '@common/enums/SummaryType';
import { IDocument } from '@common/models/Document/IDocument';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
    selector: 'app-doc-summary-generation-select-dialog',
    templateUrl: './doc-summary-generation-select-dialog.component.html',
    styleUrls: ['./doc-summary-generation-select-dialog.component.scss'],
    providers: [RadioButtonModule],
})
export class DocSummaryGenerationSelectDialogComponent {
    selectedSummaryType: SummaryType = SummaryType.CIM;
    constructor() {}
    @Input() showdialog: boolean;
    @Input() selectedDocForSummary: IDocument;
    @Output() emitSummaryForDoc: EventEmitter<SummaryType> = new EventEmitter();
    @Output() closeDialog: EventEmitter<boolean> = new EventEmitter();

    emitSummary() {
        this.emitSummaryForDoc.emit(this.selectedSummaryType);
    }
    onClose() {
        this.closeDialog.emit(false);
    }
}
